import { AfterContentChecked, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { BulkSubscription, Compass, CompassStateModel, CompassService, DeleteBulkSubscriptionAssignment, GetPageOfAssignments, AssignmentItem, AssignmentsPage, Log, BulkSubscriptionSummary, GetBulkSubscriptionSummary, Provider, CommonService, Config, CompassCopyControl, CompassAccessControl, BulkSubscriptionStateModel } from 'huddyapi';
import { Observable, Subscription, timer } from 'rxjs';
import { AppComponent } from '../app.component';
import { ConfirmationDialog } from '../components/confirmation-dialog/confirmation-dialog.component';
import { EditAssignmentDialog } from '../components/edit-assignment-dialog/edit-assignment-dialog.component';
import { DesktopErrorHandler } from '../services/errorHandler.service';
import { Util } from '../components/util';

@Component({
  selector: 'compass-detail',
  templateUrl: './compass-detail.component.html',
  styleUrls: ['./compass-detail.component.scss']
})
export class CompassDetailComponent implements OnInit {
  @Select(state => state.compassState) compassState$: Observable<CompassStateModel>;
  @Select(state => state.bulksubscriptionState) bulkSubscriptionStateModel$: Observable<BulkSubscriptionStateModel>;
  // @Select(state => state.bulksubscriptionState.currentSummary) summary$: Observable<BulkSubscriptionSummary>;
  // assignmentsSubscription: Subscription;
  // summarySubscription : Subscription;
  bulkSubscriptionStateSub : Subscription;
  summary : BulkSubscriptionSummary;
  bulkSubscriptionId : number;
  providerId : number;
  provider : Provider;
  bulkSubscription : BulkSubscription;
  compass : Compass;
  searchField : string = '';
  assignments : AssignmentItem[] = [];
  page : AssignmentsPage;
  pageNum : number = 0;
  pageSize : number = 10;
  sort : string = 'friendlyName';
  sortDir : string = 'asc';
  loading : boolean;
  displayedColumns: string[] = [
    'patientIdentifier', 
    'friendlyName',
    'assessmentTaker',
    'recommendation',
    'score',
    'scoreDate',
    'subjectScoreLevel',
    'assignedBy',
    'assignedDt',
    'actions'
  ];
  tabIndex : number = 0;

  constructor(
    private store: Store,
    private dialog: MatDialog,
    private errorHandler: DesktopErrorHandler,
    private route: ActivatedRoute,
    public router: Router,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private commonService : CommonService,
    private config: Config
  ) {
    this.matIconRegistry.addSvgIcon('patient',  domSanitizer.bypassSecurityTrustResourceUrl('./assets/ic_patients.svg'));
    this.matIconRegistry.addSvgIcon('copy',  domSanitizer.bypassSecurityTrustResourceUrl('./assets/copy.svg'));
    this.matIconRegistry.addSvgIcon('edit',  domSanitizer.bypassSecurityTrustResourceUrl('./assets/ic_edit.svg'));
    this.matIconRegistry.addSvgIcon('report',  domSanitizer.bypassSecurityTrustResourceUrl('./assets/ic_report.svg'));
    this.matIconRegistry.addSvgIcon('delete',  domSanitizer.bypassSecurityTrustResourceUrl('./assets/ic_delete.svg'));

  }

  ngOnInit() {
    this.assignments = [];
    this.summary = undefined;
    this.bulkSubscriptionId = parseInt(this.route.snapshot.paramMap.get('bulkSubscriptionId'));
    this.getPageOfAssignments();
    this.compassState$.subscribe((model: CompassStateModel) => {
      this.bulkSubscription = model.subscriptions.find(s => s.id === this.bulkSubscriptionId);
      if (this.bulkSubscription) {  
        this.compass = CompassService.getIdMappedCompass(this.bulkSubscription.compass, true, true); 
        console.log('Bulksubscription', this.compass);
        this.providerId = this.bulkSubscription.providerId;
        this.provider = model.providers.find(p => p.id === this.providerId);
        console.log('provider', this.provider, model.providers);
      } else {
        //we need to reinitialize
      }
      
    });
    this.bulkSubscriptionStateSub = this.bulkSubscriptionStateModel$.subscribe((stateModel: BulkSubscriptionStateModel) => {
      if (stateModel) { 
        if (stateModel.currentAssignmentsPage && this.assignments.length === 0 && stateModel.currentAssignmentsPage.content.length > 0) {
          const assignmentsPage = stateModel.currentAssignmentsPage;
          Log.logClassLevel(0, 'Compass-detail', 'assignmentsPage', assignmentsPage);
            this.assignments = [];
            this.page = assignmentsPage;
            if (assignmentsPage && assignmentsPage.content)  {
              if (assignmentsPage.content.length > 0 && assignmentsPage.content[0].bulkSubscriptionId === this.bulkSubscriptionId) {
                this.assignments = this.assignments.concat(assignmentsPage?.content);
              }
              this.loading = false;
            }
            Log.logClassLevel(0, 'Compass-detail', 'assignmentsPage', this.assignments, this.page);
            this.store.dispatch(new GetBulkSubscriptionSummary(this.bulkSubscriptionId));
          }
          if (stateModel.currentSummary) {
              this.summary = stateModel.currentSummary;
              Log.logClassLevel(0, 'Compass-detail', 'summary', this.summary);
          }
      }
    });
    
  }
  getPatientName(assignment : AssignmentItem) : string {
    let ret : string = assignment.friendlyName;
    if (!ret || ret.indexOf("null ") > -1) {
      ret = assignment.patientUsername;
    }
    return ret;
  }

  getNumberOfAssignments() : number {
    if (this.page) {
      return this.page.totalElements;
    }
  }

  getPageOfAssignments() {
    this.loading = true;

    this.store.dispatch(new GetPageOfAssignments(this.bulkSubscriptionId, this.pageNum, this.pageSize,  this.searchField, this.sort, this.sortDir))
  }

  pageAssignmentList($event) {
    if (this.pageSize === $event.pageSize) {
      this.pageNum = $event.pageIndex;
    } else {
      this.pageNum = 0;
    }
    this.pageSize = $event.pageSize;
    this.getPageOfAssignments();
  }

  clearSearchField() {
    this.searchField = '';
    this.getPageOfAssignments();
  }

  search($event) {
    
    this.pageNum = 0;
    console.log($event,this.searchField, $event.target.value);
    this.getPageOfAssignments();
  } 

  changeSort($event) {
    //this.loading = true;
    this.sort = $event.active;
    this.sortDir = $event.direction;
    this.getPageOfAssignments();
  }

  getPageNumber() : number {
    let ret : number = 0;
    if (this.page) {
      ret = this.page.number;
    }
    return ret;
  }

  getAssessmentTakerIdentifier(assignment : AssignmentItem) :string {
    return assignment.assessmentTakerEmail;
  }

  setTab(tabIndex: number) {
    this.tabIndex = tabIndex;
  }

  getScoreValue(assignment : AssignmentItem) :string {
    
    if (assignment.scoreValue) {
      let s : string = ''+assignment.scoreValue;
      if (assignment.scoreValue && s.indexOf('.')) {
        return ''+(assignment.scoreValue.toFixed(2));
      } else {
        return s;
      }
    }
    return '-';
  }

  getScoreRecommendation(assignment : AssignmentItem) :string {
    
    if (assignment.scoreDescription) {
     return assignment.scoreDescription;
    }
    return '-';
  }

  gotoReport(assignment : AssignmentItem) {
    if (CommonService.jwt && CommonService.jwt.length > 7) {
      let token : string = CommonService.jwt.substring(7);
      let url : string = this.config.getEndpoint() + '/report-for-subscription?subscriptionId=' + assignment.guidanceSubscriptionId + '&access_token=' + token;
      window.open(url);      
    }
  }

  gotoPatient(assignment : AssignmentItem) {
    this.router.navigateByUrl('/patient/' + assignment.patientId);
  }

  onDelete(assignment : AssignmentItem) {
 
      this.dialog.open(ConfirmationDialog, {
        width: '636px',
        data: {
          minWidth: '127px',
          title: 'Delete ' + alert.name,
          body: 'Are you sure you want to delete this assignment?',
          buttons: [
            {
              text: 'Cancel',
              class: 'secondary',
              handler: (): boolean => {
                return false;
              }
            },
            {
              text: 'Confirm',
              class: '',
              handler: () => {
                console.log('entering remove', assignment);
                this.store.dispatch(new DeleteBulkSubscriptionAssignment(assignment.bulkSubscriptionAssignmentId))
                .subscribe(t => {});
                timer(3000).subscribe(t => this.getPageOfAssignments()), err => console.error(err);
              }
            }]
          }
      });
    }

    onAdd() {
      this.onEdit(null);
    }

    sanitizeIdentifier(identifier) : string {
      return Util.sanitizePatientIdentifier(identifier);
    }

    onEdit(assignment : AssignmentItem) {
      if (assignment && assignment.scoreDate) {
        return;
      }
  
      let data = {
        mode : 'compass',
        patientId : assignment ? assignment.patientId : -1,
        assessmentTakerEmail : assignment ? 
          assignment.assessmentTakerEmail === 'Self' ? 
          assignment.patientUsername : assignment.assessmentTakerEmail : '',
        assignedDt : assignment ? assignment.assignedDt : new Date(),
        assignedBy :  assignment ? assignment.assignedBy : this.commonService.getCurrentUserToView(),
        compassId : this.compass.id,
        patientUsername : assignment ? assignment.patientUsername : '',
        bulkSubscriptionId : this.bulkSubscriptionId ,
        bulkSubscriptionAssignmentId:  assignment ? assignment.bulkSubscriptionAssignmentId : -1,
        guidanceSubscriptionId : assignment ? assignment.guidanceSubscriptionId : -1,
        subjectScoreLevel : assignment? assignment.subjectScoreLevel : 'DETAILED',
        patientFriendlyName : assignment ? assignment.friendlyName : '',
        patientUserId : assignment ? assignment.patientUserId : -1
      }

      console.log('assignment', data);
        
      const dialogRef = this.dialog.open(EditAssignmentDialog, {
        width: '700px',
        height: '350px',
        data: data
      });
      dialogRef.afterClosed().subscribe(result => {
        timer(2000).subscribe(t => this.getPageOfAssignments());
      });
  
    }

    checkSearchValue($event) {
      this.searchField = this.searchField.replace(/[^a-zA-Z0-9 '-.]/g, '');
    }

    isCopyable(): boolean {
     
      return (this.compass?.accessControl || []).findIndex((control: CompassCopyControl): boolean => control.accessControl == CompassAccessControl.COMPASS_COPYABLE) == -1;
    }
    ngOnDestroy() {
      this.bulkSubscriptionStateSub.unsubscribe();
      this.assignments = [];
      this.summary = null;
      this.bulkSubscription = null;
      this.compass = null;
    }

    copy() {
      console.log('enter copy');
      AppComponent.compassToCopy = this.compass;
      this.router.navigate(['builder']).then((navigated: boolean) => {
        if(!navigated) {
          AppComponent.compassToCopy = null;
          this.errorHandler.handleSimple(null, 'Error copying compass');
        }
      }).catch((error: any) => {
        AppComponent.compassToCopy = null;
        this.errorHandler.handleSimple(error, 'Error copying compass');
      });
    }
}


